<template>
  <v-dialog v-model="dialog" persistent max-width="400">
    <template v-slot:activator="{ on, attrs }">
      <v-tooltip v-bind="attrs" v-on="on" top>
        <template v-slot:activator="{ on, attrs }">
          <v-btn
            :class="$vuetify.breakpoint.xs ? 'mt-2' : 'd-block'"
            v-bind="attrs"
            v-on="on"
            small
            outlined
            color="warning"
            rounded
            @click="openDialog()"
          >
            {{
              `${$t("suspendedSince")} ${suspensionData.suspension_start_date}`
            }}
          </v-btn>
        </template>
        <span> {{ $t("suspensionDetails") }}</span>
      </v-tooltip>
    </template>
    <v-card>
      <v-toolbar dense>
        {{ $t("suspensionDetails") }}
        <v-spacer></v-spacer>
        <v-btn icon @click="closeDialog()">
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </v-toolbar>

      <v-card-text class="mt-4">
        <span>
          {{ `${$t("suspendedBy")}: ${suspensionData.suspension_author}` }}
        </span>
        <br />
        <span>
          {{ `${$t("date")}: ${suspensionData.suspension_start_date}` }}
        </span>
        <br />
        <template v-if="suspensionData.limite_suspensao">
          <span>
            {{
              `${$t("limitSuspensionDate")}: ${suspensionData.limite_suspensao}`
            }}
          </span>
          <br />
        </template>
        <v-divider class="my-3"></v-divider>
        <span>
          {{ `${$t("suspensionReason")}: ${suspensionData.reason}` }}
        </span>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  props: ["suspensionData"],
  name: "backoffice-administrator-users-create-new-promotion",
  data: () => ({
    limitedSuspension: true,
  }),
  computed: {
    dialog() {
      return this.$store.state.showDialog;
    },
  },
  methods: {
    closeDialog() {
      this.$store.commit("showDialog", false);
    },
    openDialog() {
      this.$store.commit("showDialog", true);
    },
  },
};
</script>
